export default{errors:{noView:'Failed to find view for property with view id:',bindingError:'Binding error. Property not found for binding'}};